/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Heading_Exp_PrefixInputs */

const en_heading_exp_prefix = /** @type {(inputs: Heading_Exp_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronological`)
};

const ar_heading_exp_prefix = /** @type {(inputs: Heading_Exp_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`السجل`)
};

const bn_heading_exp_prefix = /** @type {(inputs: Heading_Exp_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কাজের`)
};

const de_heading_exp_prefix = /** @type {(inputs: Heading_Exp_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronologisches`)
};

const es_heading_exp_prefix = /** @type {(inputs: Heading_Exp_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cronológico`)
};

const fr_heading_exp_prefix = /** @type {(inputs: Heading_Exp_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Journal`)
};

const pt_heading_exp_prefix = /** @type {(inputs: Heading_Exp_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro`)
};

const zh_heading_exp_prefix = /** @type {(inputs: Heading_Exp_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`按时间顺序`)
};

const tr_heading_exp_prefix = /** @type {(inputs: Heading_Exp_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kronolojik`)
};

const ru_heading_exp_prefix = /** @type {(inputs: Heading_Exp_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Хронологический`)
};

const pl_heading_exp_prefix = /** @type {(inputs: Heading_Exp_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chronologicznie`)
};

/**
* | output |
* | --- |
* | "Chronological" |
*
* @param {Heading_Exp_PrefixInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const heading_exp_prefix = /** @type {((inputs?: Heading_Exp_PrefixInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Heading_Exp_PrefixInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_heading_exp_prefix(inputs)
	if (locale === "bn") return bn_heading_exp_prefix(inputs)
	if (locale === "de") return de_heading_exp_prefix(inputs)
	if (locale === "es") return es_heading_exp_prefix(inputs)
	if (locale === "fr") return fr_heading_exp_prefix(inputs)
	if (locale === "pt") return pt_heading_exp_prefix(inputs)
	if (locale === "zh") return zh_heading_exp_prefix(inputs)
	if (locale === "tr") return tr_heading_exp_prefix(inputs)
	if (locale === "ru") return ru_heading_exp_prefix(inputs)
	if (locale === "pl") return pl_heading_exp_prefix(inputs)
	return en_heading_exp_prefix(inputs)
});